module.exports = __webpack_public_path__ + "static/media/san_diego_city_college_logo.2b24e48f.jpg";